import React, {FC} from 'react'
import styles from './styles/index.module.scss'

interface IInputsSession {
    changeSession:(e:number)=>void
    value: string;
    name: string,
    disable?: boolean
}
const InputsSession:FC<IInputsSession> = ({changeSession, value,name,disable}) => {
    const sessionInputs = [
        { id: 1, title: '1,5', minutes: 1.5 },
        { id: 2, title: '2,5', minutes: 2.5 },
        { id: 3, title: '3', minutes: 3  },
        { id: 4, title: 'Без перерыва', minutes: 0 },
    ]
    return (
        <div className={styles['input-session']}>
            {sessionInputs.map(({ title, minutes,id }) => {
                return (
                    <label key={id}>
                        <input className={styles['input-session--radio']} name={name} disabled={disable} type='radio' onChange={()=> changeSession(minutes)} checked={Number(value) === minutes}/>
                        <div className={styles['input-session--block']}>
                            {minutes !== 0  && <time className={styles['input-session--time']}>{title}</time>}
                            <p className={styles['input-session--label-minutes']}>{minutes !==0 ? 'мин.' : title}</p>
                        </div>
                    </label>
                )
            })}
        </div>
    )
}

export default InputsSession;